export default "__VITE_ASSET__03bdebfe__"